import { useState, useEffect } from "react";
import { DateRangePicker } from "react-date-range";
import { RajasthanDrawal } from "./Demand/Drawal"; // Importing the required component
import { RajasthanDiscomAnalysis } from "./Demand/Discom_Analysis";
import { FilterTab } from "../../components/Filters";
import { RajasthanDiscomForecast } from "./Demand/Forecast";
import { ReactComponent as Upload } from "../../icons/upload.svg";
import RajasthanGnaTgna from "./Procurement/GnaTgna";
import Collective from "./Procurement/Collective";
import ISGS from "./Generation/ISGS";
import { RajGenOverview } from "./Generation/Overview";

const TABS = [
  "Restricted Demand",
  "Discom Load",
  "Forecast",
  "Generation",
  "GNA/TGNA",
  "ISGS",
  "Collective",
];

export function Rajasthan() {
  // Get initial tab from URL or default to "Restricted Demand"
  const initialTab =
    new URLSearchParams(window.location.search).get("tab") ||
    "Restricted Demand";
  const [isDatePickerOpen, setIsDatePickerOpen] = useState(false);
  const [selectedTab, setSelectedTab] = useState(initialTab);
  const [dateRange, setDateRange] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },
  ]);

  // Handle tab click and update URL
  const handleTabChange = (option: string) => {
    setSelectedTab(option);
    // Update the URL without reloading the page
    const url = new URL(window.location as any);
    url.searchParams.set("tab", option);
    window.history.pushState({}, "", url);
  };

  useEffect(() => {
    // Update selected tab if URL changes
    const handlePopState = () => {
      const tab = new URLSearchParams(window.location.search).get("tab");
      if (tab && TABS.includes(tab)) {
        setSelectedTab(tab);
      }
    };

    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, []);

  const handleDownload = () => {
    const { startDate, endDate } = dateRange[0];
    alert(
      `Downloading file for date range: ${startDate.toLocaleDateString()} - ${endDate.toLocaleDateString()}`
    );
    setIsDatePickerOpen(false); // Close the date picker after download
  };

  const handleDateChange = (item: any) => {
    const selection = item.selection;
    setDateRange([
      {
        startDate: selection.startDate || new Date(), // Provide default value
        endDate: selection.endDate || new Date(), // Provide default value
        key: selection.key || "selection",
      },
    ]);
  };

  return (
    <div className="h-full w-full anirudh">
      <div className="header flex items-center justify-between">
        <h1>Rajasthan</h1>
        <FilterTab
          options={TABS}
          onClick={(option, index) => handleTabChange(option)}
          selected={[selectedTab]}
        />
        <a
          href="https://ruvitl.gna.energy/upload"
          className="downloadButton flex items-center gap-x-2 p-4"
        >
          <Upload fill={"white"} height={25} width={25} />
          Upload
        </a>
      </div>
      {selectedTab === "Restricted Demand" && <RajasthanDrawal />}
      {selectedTab === "Discom Load" && <RajasthanDiscomAnalysis />}
      {selectedTab === "Forecast" && <RajasthanDiscomForecast />}
      {selectedTab === "Generation" && <RajGenOverview />}
      {selectedTab === "GNA/TGNA" && <RajasthanGnaTgna />}
      {selectedTab === "ISGS" && <ISGS />}
      {selectedTab === "Collective" && <Collective />}

      <div className="betaText">Beta Version</div>
    </div>
  );
}
